<template>
  <div id="userForm">
    <v-overlay :value="loading" z-index="6">
      <v-progress-circular indeterminate size="64"/>
    </v-overlay>
    <v-row no-gutters justify="start">
      <v-col cols="9">
        <v-card class="pa-3">
          <v-card-title>
            <h4>{{$t($route.meta.breadcrumb[2].text)}}</h4>
          </v-card-title>
          <v-card-subtitle>
            <p>{{$t('users.formMessage')}}</p>
          </v-card-subtitle>
          <v-card-text>
            <v-progress-linear v-if="isEdit && loadItem" color="primary" indeterminate/>
            <p v-if="isEdit && loadItem" class="text-center">{{$t('general.loading')}}</p>
            <v-form
              lazy-validation
              ref="form"
              v-model="valid"
              v-if="!loadItem || !isEdit"
            >
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.textRules"
                    v-model="editedItem.name"
                  >
                    <template v-slot:label>
                      <span>{{$t('general.name')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    outlined
                    dense
                    :label="$t('general.lastNames')"
                    :rules="rules.textNoReq"
                    v-model="editedItem.last_name"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.email"
                    v-model="editedItem.email"
                  >
                    <template v-slot:label>
                      <span>{{$t('general.email')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-if="editedIndex === 0"
                    outlined
                    dense
                    :rules="rules.validPassword"
                    v-model="editedItem.password"
                    :type="!viewPass ? 'password' : 'text'"
                    :append-icon="!viewPass ? 'visibility' : 'visibility_off'"
                    @click:append="viewPass = !viewPass"
                  >
                    <template v-slot:label>
                      <span>{{$t('login.password')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                  <v-text-field
                    v-else
                    outlined
                    dense
                    :label="$t('login.password')"
                    v-model="editedItem.password"
                    :type="!viewPass ? 'password' : 'text'"
                    :append-icon="!viewPass ? 'visibility' : 'visibility_off'"
                    @click:append="viewPass = !viewPass"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    outlined
                    dense
                    :label="$t('general.phone')"
                    v-mask="'(###) ###-####'"
                    :rules="rules.digit"
                    v-model="editedItem.phone"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    outlined
                    dense
                    :label="$t('general.licence')"
                    :rules="rules.textNoReq"
                    v-model="editedItem.license_number"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    outlined
                    dense
                    :items="roles"
                    item-text="name"
                    item-value="id"
                    :rules="rules.required"
                    v-model="editedItem.roles[0].id"
                  >
                    <template v-slot:label>
                      <span>{{$t('general.role')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="6" v-if="userLogged.roles && userLogged.roles[0].id === 1">
                  <v-autocomplete
                    outlined
                    dense
                    :items="companies"
                    item-text="name"
                    item-value="id"
                    :rules="rules.required"
                    v-model="editedItem.company_id"
                  >
                    <template v-slot:label>
                      <span>{{$t('general.company')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-btn
                    class="mr-4"
                    color="primary"
                    outlined
                    @click="redirect"
                  >{{$t('general.cancel')}}</v-btn>
                  <v-btn
                    color="primary"
                    depressed
                    @click="add"
                  >{{$t('general.save')}}</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import {mask} from 'vue-the-mask'
export default {
  name: 'userForm',
  directives: {mask},
  data () {
    return {
      loadItem: true,
      loading: false,
      valid: true,
      viewPass: false,
      editedIndex: 0,
      companies: [],
      options: {
        total: 0
      },
      editedItem: {
        id: 0,
        name: '',
        last_name: '',
        email: '',
        password: '',
        phone: '',
        license_number: '',
        roles: [
          {
            id: 0,
            name: ''
          }
        ],
        company: ''
      },
      defRoles: [
        {id: 1, name: 'SUPER_ADMIN'},
        {id: 2, name: 'ADMIN'},
        {id: 3, name: 'INSPECTOR'},
        {id: 4, name: 'OPERADOR'},
      ]
    }
  },
  watch: {
    userLogged (val) {
      if (val.roles && val.roles[0].id === 1) {
        this.$store.dispatch('company/get', {event: {item: {perPage: -1, page: 1}, context: this}})
      } else if (val.roles && val.roles[0].id === 2) {
        this.editedItem.company_id = val.comapnies[0].id
      }
    }
  },
  created () {
    if (this.userLogged.roles && this.userLogged.roles[0].id === 1) {
      this.$store.dispatch('company/get', {event: {item: {perPage: -1, page: 1}, context: this}})
    }
    if (this.$route.params.id) {
      let id = this.$route.params.id
      this.$store.dispatch('users/getById', {event: {id: id, context: this}})
    }
  },
  computed: {
    isEdit () {
      if (this.$route.params.id) {
        return true
      } else {
        return false
      }
    },
    rules () {
      return this.$validationRules()
    },
    role () {
      if (this.$store.state.userLogged.roles) {
        return this.$store.state.userLogged.roles[0].id
      } else {
        return 0
      }
    },
    roles () {
      if (this.role === 1) {
        return [this.defRoles[1]]
      } else {
        return this.defRoles.slice(1, 4)
      }
    },
    userLogged () {
      return this.$store.state.userLogged
    }
  },
  methods: {
    add () {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedIndex === 0) {
          this.post()
        } else {
          this.put()
        }
      }
    },
    post () {
      this.$store.dispatch('users/post', {event: {item: this.editedItem, context: this}})
    },
    put () {
      this.$store.dispatch('users/put', {event: {item: this.editedItem, context: this}})
    },
    redirect () {
      this.$router.push('/users')
    }
  }
}
</script>